export default __webpack_public_path__ + "static/media/850.c1ff174d.png";